import axios from "axios"
import { isEmpty, set, get, merge, startsWith, isUndefined } from "lodash"
import uuid from "uuid"
import store from "redux/store"

import APIs from "redux/apis"
import { Config } from "config/config"
import { UserStorage } from "./userStorage"
import { FeatureCollection } from "geojson"
import { sessionTimeOut } from "redux/ducks/SessionTimeOut"
import { pageLoadRegist } from "../redux/ducks/PageLoad"

export type RequestLogin<T> = <Promise>(
  user_branch: string,
  user_id: string,
  user_pw: string
) => T
export type RequestAPI<T> = <Promise>(params?: object, headers?: object) => T

export const getApiData = async (
  category: string,
  path: string,
  header: object,
  request: object,
  setResult: Function
) => {
  const req = get(APIs, `${category}.${path}`, false)
  const result = req ? await req(header, request) : {}
  setResult(result)
}

const getStubPath = (path: string, params: object = {}) => {
  //PriceList
  if (path === "Message/PriceList" && typeof get(params, "Name") === "string") {
    const nextLevelPath = get(params, "Name")
      .split(".")
      .join("")
    return `./stub/api/${path}/${nextLevelPath}.json`
    //News
  } else if (path === "Message/News") {
    const isTopN = get(params, "TopN")
    const _Take = get(params, "_take")
    if (!isUndefined(isTopN)) {
      return `./stub/api/${path}/TopN.json`
    } else if (!isUndefined(_Take)) {
      return _Take === 1
        ? `./stub/api/${path}/Take1.json`
        : _Take === 5
        ? `./stub/api/${path}/Take5.json`
        : _Take === 10
        ? `./stub/api/${path}/Take10.json`
        : `./stub/api/${path}/Detail.json`
    }
    //SymbolList
  } else if (path === "Message/SymbolList") {
    const LimitType = get(params, "LimitType")
    const nextLevelPath = String(get(params, "TargetSecurityTypes"))
      .split(",")
      .join("_")
    return nextLevelPath === "1"
      ? `./stub/api/${path}/TargetSecurityTypes/${nextLevelPath}/LimitType/${LimitType}.json`
      : `./stub/api/${path}/TargetSecurityTypes/${nextLevelPath}.json`
    //EquitySymbolList
  } else if (path === "Message/EquitySymbolList") {
    const isIndexKeyword = get(params, "IndexKeyword")
    const isTPSectors = get(params, "TPSectors")
    const isMarkets = get(params, "Markets")
    if (!isUndefined(isIndexKeyword)) {
      return `./stub/api/${path}/NK225.json`
    }
    if (!isUndefined(isTPSectors)) {
      return `./stub/api/${path}/TPSectors.json`
    }
    if (!isUndefined(isMarkets)) {
      return `./stub/api/${path}/Market.json`
    }
    //SettledAccountReport
  } else if (path === "Message/SettledAccountReport") {
    const nextLevelPath = get(params, "Type")
    return `./stub/api/${path}/Type/${nextLevelPath}.json`
  } else {
    return `./stub/api/${path}.json`
  }
}

//認証なしリクエスト
export const request = async (
  method: string,
  path: string,
  params: object = {},
  header: object = {},
  isStub: boolean = true
) => {
  if (
    (process.env.NODE_ENV !== "production" &&
      (get(Config.api, "stub", false) && get(Config, "debug", false))) ||
    isStub
  ) {
    path = getStubPath(path, params)
    method = "GET"
  } else {
    path = Config.api.rootUrl + path
  }
  const options = {
    method: method.toLowerCase() as "GET" | "POST",
    url: path,
  }
  // パラメタ指定
  if (!isEmpty(params)) {
    switch (method) {
      case "POST":
        set(options, "data", params)
        break
      default:
        set(options, "params", params)
    }
  }
  if (!isEmpty(header)) set(options, "headers", header)
  const start = performance.now()
  const res = await axios(options).catch((err: object) => {
    const api_error = get(err, "response.headers.x-api-error")
    if (startsWith(api_error, "003")) {
      window.location.href = "./#/sessionTimeOut"
      store.dispatch(sessionTimeOut())
      UserStorage.sessionTimeout.set({ sessionTimeout: true })
    }
    throw err
  })

  const passageTime = performance.now() - start
  if (passageTime > 1000 && process.env.NODE_ENV !== "production") {
    console.warn(path, passageTime + "ms")
  }
  return res.data
}

//認証ありリクエスト
export const auth_request = async (
  method: string,
  path: string,
  params: object = {},
  header: object = {},
  isStub: boolean = false
) => {
  const SessionId = UserStorage.User.getSessionId()
  if (!SessionId) {
    return Promise.reject("[API auth request] session timeout")
  }
  const basic_header = {
    "X-SessionID": SessionId,
    "X-Api-Version": Config.api.version,
    RequestID: uuid() + "@" + Config.api.account,
    FrontChannelID: "",
    ScreenHistory: "",
    "Cache-Control": "no-store",
    Pragma: "no-cache",
    Expires: -1,
    "Access-Control-Expose-Headers": "X-API-Error",
  }
  const headers = merge({}, basic_header, header)
  //Demo版のためisStubをtrueに
  return request(method, path, params, headers, true).catch(err => {
    const loadingId: Array<string> = store.getState().PageLoad.id
    if (!isEmpty(loadingId)) {
      store.dispatch(pageLoadRegist(loadingId[0], false))
    }
    if (process.env.NODE_ENV !== "production") {
      console.warn(`<API REJECTED> Reason: ${err}`)
    }
    return err
  })
}

type Request_GeoJson_Type = (path: string) => Promise<FeatureCollection>
export const request_geoJson: Request_GeoJson_Type = async path => {
  const res = await axios({ url: `./stub/map/${path}.json`, method: "GET" })
  return res.data
}
